import axios from 'axios';
import { backendBaseUrl5 } from './config';
import { convertGameData, beforeSaveGame, BackendError } from './shared';

const studentApi = axios.create({
    baseURL: `${backendBaseUrl5}user/`,
});

export function callAction(token, action, parameters = {}, post = false) {
    return new Promise((resolve, reject) => {
        let params = { key: token, ...parameters };
        let call;
        if (post) {
            let formdata = new FormData();
            for (const [key, value] of Object.entries(params)) {
                formdata.append(key, value);
            }
            call = studentApi.post(action, formdata);
        } else {
            call = studentApi.get(action, {
                params,
            });
        }
        call.then((axResult) => {
            if (axResult?.data?.responsecode === 0) {
                resolve(axResult.data.data);
            } else if (axResult?.data?.responsemsg) {
                reject(new BackendError(axResult.data.responsemsg));
            } else {
                reject(new Error(`${action} error`));
            }
        }).catch((axiosError) => {
            // console.log('axiosError:', axiosError);
            reject(JSON.stringify(axiosError, 4));
        });
    });
}

/**
 * 
 * @param {string} token -  unieke key die gekoppeld is aan de combinatie user-game, 
 *      dus een bepaalde user (email-adres) kan op meerdere games registreren waarbij
 *      telkens een nieuwe key aangemaakt wordt
 * @returns 
 * 
 * data bestaat uit:
 * status: info over user, gametoken, de game zelf en acutele status (pogingen etc)
 *      status ["init" | "sim" | "ready" | "score"]
 * config: uitgeklede versie van de master config, met alleen de enabled parameters
 * game: uitgeklede versie van de master game, zonder de hidden parameters (om valsspelen tegen te gaan)
 * forecast: weersvoorspelling 
 * session: simulatiedata
 * 
 * // er zijn 2 parameters voor de ingestelde taal:
    //- writable voor master: "@language" (type=rules)
    //- hidden voor de user: "language" (type=custom)
    // bij het opslaan wordt door de API de writable-waarde naar de hidden-waarde gekopieerd. De 
       language (int) is nu beschikbaar in de rest van de GUI (0=NL,1=EN)
 */
export function login(token) {
    return callAction(token, 'Play', { action: 'pageload' }).then((res) => {
        const result = {
            ...res,
            permissionLevel: 1,
            game: convertGameData(res.game, res.config),
        };
        return result;
    });
}

export function getAdditionalUserData(token) {
    return login(token);
}

export function saveGame(token, game) {
    return callAction(token, 'SaveGame', { game: beforeSaveGame(game) }, true);
}

export function startGame(token) {
    return callAction(token, 'Play', { action: 'start' });
}

export function startSimulation(token, game, def = false) {
    return saveGame(token, game).then((r) => {
        const action = def ? 'simdef' : 'simtry';
        return callAction(token, 'Play', { action });
    });
}

export function mailResults(token) {
    return callAction(token, 'MailResults');
}

export function removeAccount(token) {
    return callAction(token, 'DeleteAccount');
}

export function replay(token) {
    return callAction(token, 'Replay');
}
